import { useContext } from 'react';

import ContextMenuContext from './ContextMenu.context';
import type { ContextMenuItem } from './ContextMenu.types';

// Use this hook to display a context memu on any html element. It must be used within a ContextMenuProvider.
export const useContextMenu = ({
  menuItems
}: {
  menuItems?: ContextMenuItem[];
} = {}) => {
  const context = useContext(ContextMenuContext);
  if (!context) {
    throw new Error('useContextMenu must be used within a ContextMenuProvider');
  }

  if (menuItems) {
    context.setMenuItems(menuItems);
  }

  return { ...context };
};

export default useContextMenu;
